import EditCustomPage from './EditCustomPage.container';

export default EditCustomPage;
